// Legacy `/bundles` alias — the canonical route is `/products/bundles`.
// Redirect here so old links keep working.
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/bundles')({
  beforeLoad: () => {
    throw redirect({ to: '/products/bundles' });
  },
});
